module.exports = __webpack_public_path__ + "static/dash-1-2fcca13d21decc8e02db2f20b4e7ea93.png";